import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=04c782e5"
import script from "./AppointmentDetail.vue?vue&type=script&lang=js"
export * from "./AppointmentDetail.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDetail.vue?vue&type=style&index=0&id=04c782e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports